import { useEffect, useState } from 'react'

/**
 * Пока key непустой — показывать true, затем через durationMs скрыть.
 * Смена key или очистка сбрасывает таймер.
 */
export function useTimedVisibility(key: string | null, durationMs: number): boolean {
    const [hidden, setHidden] = useState(false)

    useEffect(() => {
        if (!key) {
            setHidden(false)
            return undefined
        }
        setHidden(false)
        const id = window.setTimeout(() => setHidden(true), durationMs)
        return () => window.clearTimeout(id)
    }, [key, durationMs])

    return Boolean(key) && !hidden
}
